import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routeUrls } from '../../config/routes';

const AuthProtectedRoute = ({ component: Component, ...rest }) => {
  const state = useSelector(state => state);
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={props =>
        state.auth.isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: routeUrls.login,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default AuthProtectedRoute;
